import React from 'react';
import { useTranslation } from 'react-i18next';

export function Table({ children, className = '' }) {
  return (
    <div className="table-container">
      <table className={`table ${className}`}>
        {children}
      </table>
    </div>
  );
}

export function TableHead({ children }) {
  return <thead>{children}</thead>;
}

export function TableBody({ children }) {
  return <tbody className="divide-y divide-gray-200">{children}</tbody>;
}

export function TableRow({ children, onClick, className = '' }) {
  return (
    <tr
      className={`${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      {children}
    </tr>
  );
}

export function TableHeader({ children, className = '', ...props }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const alignmentClass = lang === 'ar' ? 'text-right' : 'text-left';
  return (
    <th className={`${className} ${alignmentClass}`.trim()} {...props}>
      {children}
    </th>
  );
}

export function TableCell({ children, className = '', ...props }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const alignmentClass = lang === 'ar' ? 'text-right' : 'text-left';
  return (
    <td className={`${className} ${alignmentClass}`.trim()} {...props}>
      {children}
    </td>
  );
}

export default Table;
